"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var classnames_1 = __importDefault(require("classnames"));
var build_1 = require("react-persistent-state/build");
var color_1 = require("../core/style/color");
var height = function (dense) { return dense ? 44 : 52; };
var useStyles = (0, makeStyles_1.default)(function (t) {
    var _a;
    return (0, createStyles_1.default)({
        root: (_a = {
                paddingLeft: t.spacing(2),
                paddingRight: t.spacing(2)
            },
            _a[t.breakpoints.up('sm')] = {
                paddingLeft: t.spacing(3),
                paddingRight: t.spacing(3),
            },
            _a.transition = t.transitions.create('all'),
            // @ts-ignore
            _a.minHeight = function (props) { return height(props.dense); },
            _a.display = 'flex',
            _a.alignItems = 'center',
            _a.overflow = 'hidden',
            _a.borderRadius = 4,
            // @ts-ignore
            _a.paddingLeft = function (props) { return props.dense ? t.spacing(1) : t.spacing(2); },
            _a),
        i: {
            marginRight: t.spacing(1),
            height: function (props) { return height(props.dense) + "px !important"; },
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'flex-start',
        },
        body: {
            flex: 1,
            paddingTop: function (props) { return t.spacing(props.dense ? 1 : 2); },
            paddingBottom: function (props) { return t.spacing(props.dense ? 1 : 2); },
        },
        _success: {
            background: 'rgba(50, 255, 150, .08)',
            color: (0, material_1.darken)(color_1.colorSuccess, .1),
        },
        _info: {
            background: 'rgba(50, 200, 255, .08)',
            color: (0, material_1.darken)(color_1.colorInfo, .1),
        },
        _error: {
            background: 'rgba(255, 0, 0, .08)',
            color: (0, material_1.darken)(color_1.colorError, .1),
        },
        _warning: {
            background: 'rgba(255, 128, 0, .08)',
            color: (0, material_1.darken)(color_1.colorWarning, .1),
        },
        _hidden: {
            minHeight: '0 !important',
            height: '0 !important',
            opacity: '0 !important',
            margin: '0 !important',
        },
        _gutterBottom: {
            marginBottom: t.spacing(1),
        },
        action: {
            textAlign: 'right',
            margin: t.spacing(1) + " " + t.spacing(1 / 2) + " " + t.spacing(1 / 2) + " 0",
            marginRight: -t.spacing(2),
        }
    });
});
var Alert = function (_a) {
    var id = _a.id, style = _a.style, type = _a.type, dense = _a.dense, children = _a.children, hidden = _a.hidden, icon = _a.icon, action = _a.action, deletable = _a.deletable, persistentDelete = _a.persistentDelete, className = _a.className, gutterBottom = _a.gutterBottom;
    var classes = useStyles({ type: type, dense: dense, children: children, icon: icon, action: action, deletable: deletable, persistentDelete: persistentDelete, className: className });
    var _b = (0, build_1.usePersistentState)(true, id || 'alert'), isPersistentVisible = _b[0], setPersistentIsVisible = _b[1];
    var _c = (0, react_1.useState)(true), isVisible = _c[0], setIsVisible = _c[1];
    var getIconFromType = function () {
        switch (type) {
            case 'info':
                return 'info';
            case 'error':
                return 'error';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
            default:
                return 'info';
        }
    };
    return (React.createElement("div", { id: id, style: style, className: (0, classnames_1.default)(className, classes.root, classes['_' + type], (hidden || !isVisible || (persistentDelete && !isPersistentVisible)) && classes._hidden, gutterBottom && classes._gutterBottom) },
        React.createElement(material_1.Icon, { className: classes.i }, icon ? icon : getIconFromType()),
        React.createElement("div", { className: classes.body }, children),
        React.createElement("div", { className: classes.action },
            action,
            deletable &&
                React.createElement(material_1.IconButton, { onClick: function () {
                        setIsVisible(false);
                        if (persistentDelete)
                            setPersistentIsVisible(false);
                    }, size: "large" },
                    React.createElement(material_1.Icon, null, "clear")))));
};
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map